import { render, staticRenderFns } from "./signupView.vue?vue&type=template&id=0c52f5e8&"
import script from "./signupView.vue?vue&type=script&lang=js&"
export * from "./signupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports